export default __webpack_public_path__ + "static/media/tmovie.67797e94.png";